<sbf-error-shell [errorNumber]="504" message1="THE SERVER ENCOUNTERED A TEMPORARY ERROR AND COULD NOT COMPLETE YOUR REQUEST" message2="KEEP EXPLORING"></sbf-error-shell>
